<script setup lang="ts">
import { ref, watch } from 'vue'
import { useAuthStore } from '@/stores/auth';
import RegisterForm from './RegisterForm.vue';
import { useRouter } from 'vue-router';

const router = useRouter()


// import { Button, Dialog, InputText } from 'primevue'
const authStore = useAuthStore()
const showRegister = ref<boolean>(false)
const closeDialogPlease = ref<boolean>(false)
const visible = defineModel<boolean>()
const headerText = ref<string>('Login')
const password = ref<string>('')

const gdprAck = ref<boolean>(false)
const showGDPRMessage = ref<boolean>(false)
const showMissingFieldsMessage = ref<boolean>(false)
const showInvalidLoginMessage = ref<boolean>(false)
const showUnspecifiedErrorMessage = ref<boolean>(false)
const qaCookies = ref<boolean>(false)

const toggleDialog = () => {
  visible.value = !visible.value
  console.log('visible:', visible.value)
}

const toggleRegister = () => {
  showRegister.value = !showRegister.value
  if (showRegister.value) {
    headerText.value = 'Register'
  }
}

const tryLogin = async () => {
  if (authStore.username === '' || password.value === '') {
    showMissingFieldsMessage.value = true
    return
  } else {
    showMissingFieldsMessage.value = false
    showGDPRMessage.value = false
    showInvalidLoginMessage.value = false
    showUnspecifiedErrorMessage.value = false
    try {
      const response = await authStore.login(authStore.username, password.value)
      if (response.ok) {
        showInvalidLoginMessage.value = false
        showUnspecifiedErrorMessage.value = false
      } else if (response.status === 401) {
        showInvalidLoginMessage.value = true
      } else {
        showUnspecifiedErrorMessage.value = true
      }
    } catch (error) {
      console.error('Login error:', error)
      showUnspecifiedErrorMessage.value = true
    }
  }
}

// watch the authStore.isAuthenticated value
watch(() => authStore.isAuthenticated, (newVal: boolean) => {
  if (newVal) {
    headerText.value = 'Logout'
  } else {
    headerText.value = 'Login'
  }
})

// Watch for the Register form closing
watch(() => showRegister.value, (newVal: boolean) => {
  if (!newVal) {
    headerText.value = 'Login'
  }
})

// Watch for a call to close everything
watch( () => closeDialogPlease.value, (newVal: boolean) => {
  if (newVal) {
    visible.value = false
    closeDialogPlease.value = false
  }
})
</script>

<template>
<Dialog v-model:visible="visible" modal :header=headerText :style="{ width: '25rem' }">
    <div class="container">
        <div v-if="!showRegister">
            <div v-if="!authStore.isAuthenticated">
                <h1>Welcome</h1>
                <span class="text-surface-500 dark:text-surface-400 block mb-8">Please login with the form below, or <a :onclick="toggleRegister">register</a> by clicking the link.</span>
                <Divider />
                <div class="mb-8">
                    <h2>Username:</h2>
                    <InputText v-model="authStore.username" placeholder="Username" @keydown.enter="tryLogin" />
                    <h2>Password:</h2>
                    <InputText v-model="password" placeholder="Password" type="password" @keydown.enter="tryLogin" />
                    <h2>Data Usage Consent</h2>
                    <!-- <div class="flex-row items-center gap-1"> -->
                      <!-- <p> -->
                        <!-- For terms and conditions, see: <a @click="router.push('/gdpr')">GDPR</a> page. -->
                         <!-- For terms and conditions see our <a href="/gdpr">data policy</a>. -->
                      <!-- </p> -->
                      <!-- <p> -->
                        <!-- Please confirm you are happy for data you enter to be stored in our database, and for session cookies to be stored on your browser. -->
                      <!-- </p> -->
                      <!-- <Checkbox v-model="gdprAck" label="I acknowledge stuff" binary /> -->
                    <!-- </div> -->
                    <div class="flex-row items-center gap-1">
                      Please accept or refuse optional cookies used for QA and performance monitoring.
                      <Checkbox v-model="qaCookies"  binary />
                    </div>
                    <div class="flex-row items-center gap-1" style="color:red; font-size:1.5rem;">
                      <!-- <div v-if="showGDPRMessage" class="err">Please read the text above regarding GDPR.</div> -->
                      <div v-if="showMissingFieldsMessage" class="err">Please fill in both username and password inputs.</div>
                      <div v-if="showInvalidLoginMessage" class="err">Invalid username or password.</div>
                      <div v-if="showUnspecifiedErrorMessage" class="err">An unexpected error occurred. Please try again later.</div>
                    </div>
                  </div>
                <div class="flex items-center mb-8 gap-1">
                    <Button type="button" label="Login" @click="tryLogin"></Button>
                    <Button type="button" label="Register" @click="showRegister = true"></Button>
                </div>
            </div>
            <div v-else>
                <span class="text-surface-500 dark:text-surface-400 block mb-8">You are currently logged in with username: {{ authStore.username }}</span>
                <Divider />
                <div class="flex items-center mb-8 gap-8">
                    <Button type="button" label="Logout" @click="authStore.logout()"></Button>
                </div>
            </div>
        </div>
        <div v-else>
            <RegisterForm v-model:showRegister="showRegister" v-model:closeDialogPlease="closeDialogPlease" />
        </div>
    </div>
</Dialog>
</template>

<style scoped>
.err {
    color: red;
}
</style>